import React, { useEffect, useState } from 'react';
import AuthShowcase from './AuthShowcase';
import '../../styles/auth-login.css';

/** Shared RobiTest mark used in auth card headers. */
export const AuthBrandLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 215 215"
    fill="none"
    className="auth-logo"
    aria-hidden
  >
    <path
      d="M115 10C115 4.47715 110.523 0 105 0C99.4772 0 95 4.47715 95 10V30C95 35.5228 99.4772 40 105 40C110.523 40 115 35.5228 115 30V10Z"
      fill="#4285F4"
    />
    <path
      d="M105 60C66.3401 60 35 91.3401 35 130V170C35 192.091 52.9086 210 75 210H135C157.091 210 175 192.091 175 170V130C175 91.3401 143.66 60 105 60Z"
      stroke="#4285F4"
      strokeWidth="20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75 130C75 130 75 120 75 115C75 110 80 105 85 105C90 105 95 110 95 115C95 120 95 130 95 130"
      stroke="#4285F4"
      strokeWidth="20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M115 130C115 130 115 120 115 115C115 110 120 105 125 105C130 105 135 110 135 115C135 120 135 130 135 130"
      stroke="#4285F4"
      strokeWidth="20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75 170H135"
      stroke="#4285F4"
      strokeWidth="20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Theme-aware auth layout matching Login: brand showcase + surface card.
 * Pass `footer={null}` to omit the card footer.
 */
const AuthPageShell = ({
  title,
  subtitle,
  children,
  footer,
  headerExtra = null,
  cardStyle,
  bodyStyle,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const year = new Date().getFullYear();
  const showDefaultFooter = footer === undefined;

  return (
    <div className="auth-container auth-container--rt">
      {!isMobile && (
        <div className="auth-left-section">
          <AuthShowcase />
        </div>
      )}

      <div className={`auth-right-section${isMobile ? ' mobile-full' : ''}`}>
        <div className="auth-card" style={cardStyle}>
          {(title || subtitle || headerExtra) && (
            <div className="auth-header">
              {headerExtra || <AuthBrandLogo />}
              {title ? <h1 className="auth-title">{title}</h1> : null}
              {subtitle ? <p className="auth-subtitle">{subtitle}</p> : null}
            </div>
          )}

          <div className="auth-body" style={bodyStyle}>
            {children}
          </div>

          {footer !== null && (
            <div className="auth-footer">
              {showDefaultFooter ? (
                <p>&copy; {year} RobiTest. All rights reserved.</p>
              ) : (
                footer
              )}
            </div>
          )}
        </div>

        {isMobile && (
          <p className="auth-page-copy">&copy; {year} RobiTest. All rights reserved.</p>
        )}
      </div>
    </div>
  );
};

export default AuthPageShell;
